import React from 'react';
import { Handle, Position } from 'reactflow';
import { Layers } from 'lucide-react';
import './NodeStyles.css';

/**
 * PackageNode (WP-8) — a bound library package reads as an indigo stacked/
 * contained card ("contains more than it shows"). No emoji. Header = indigo
 * Layers badge + PACKAGE kicker + version (and a stale "update" pill when the
 * library has a newer version); body = title; footer = question count +
 * instance name.
 */
const PackageNode = ({ data, selected }) => {
  const isStale = !!data?.isStale;
  const version = data?.packageVersion ?? data?.version ?? '1.0';
  const title = data?.title || 'Untitled package';
  const description = data?.description;
  const questionCount = data?.questionCount || 0;
  const pluralSuffix = questionCount === 1 ? '' : 's';
  const instanceName = data?.instanceName || '';
  const hasError = !!data?.error;

  return (
    <div className={`package-node ${selected ? 'selected' : ''} ${hasError ? 'node-error' : ''}`}>
      <Handle type="target" position={Position.Top} className="node-handle node-handle-top" />

      <div className="pkg-header">
        <div className="pkg-badge">
          <Layers size={13} />
        </div>
        <span className="pkg-kicker">PACKAGE</span>
        {isStale && <span className="pkg-stale">update</span>}
        <span className="pkg-version">v{version}</span>
      </div>

      <div className="pkg-body">
        <div className="pkg-title">{title}</div>
        {description && (
          <div className="pkg-desc" title={description}>
            {description}
          </div>
        )}
      </div>

      <div className="pkg-footer">
        <span className="pkg-count">
          {questionCount} question{pluralSuffix}
        </span>
        {instanceName && <span className="pkg-instance">{instanceName}</span>}
      </div>

      <Handle type="source" position={Position.Bottom} className="node-handle node-handle-bottom" />
    </div>
  );
};

export default PackageNode;
